module.exports = require("element-ui/src/locale/lang/de");